module.exports = __webpack_public_path__ + "img/nav-item-bg.5fc11bdb.png";